import React, { useEffect } from "react";
import "@fortawesome/fontawesome-free/js/all.js";
import "./assets/scss/custom.scss";
import "./App.css";
import Layout from "layout";
import Router from "router";
import { addToken } from "services";
import { connect } from "react-redux";
import { SetUser } from "redux/actions/userActions";
import { SetLoggedIn } from "redux/actions/isLoggedInActions";
import { SetHasPersonalData } from "redux/actions/hasPersonalDataReducerActions";
import { SetHasVehicle } from "redux/actions/hasVehicleDataActions";
import { SetHasFamilyStructure } from "redux/actions/hasFamilyStructureDataActions";
import { SetHasEducation } from "redux/actions/hasEducationDataActions";
import { SetHasLanguage } from "redux/actions/hasLanguageDataActions";
import { SetHasKnowledge } from "redux/actions/hasKnowledgeDataActions";
import { SetHasExperience } from "redux/actions/hasExperienceDataActions";
import { SetHasRefenceData } from "redux/actions/hasReferenceDataActions";
import { SetHasJobInformation } from "redux/actions/hasJobInformationDataActions";
import { SetHasAttachment } from "redux/actions/hasAttachmentDataActions";
import { SetIsRequiredModule } from "redux/actions/isRequiredModuleActions";
import { useHistory } from "react-router";
import { get } from "services";
import { SetHasTalentsData } from "redux/actions/hasTalentsActions";

const App = (props) => {
  const history = useHistory();

  useEffect(() => {
    (async function mounted() {
      if (props.isLoggedIn) {
        if (localStorage.getItem("token-ARS")) {
          try {
            addToken();

            const response = await get("Usuario/IsValidToken");

            if (
              response &&
              response.data &&
              response.data.message == "Authorized"
            ) {
              if (
                props.user.persona &&
                props.user.persona.fechaNacimiento &&
                props.user.persona.fechaNacimiento != "0001-01-01T00:00:000"
              ) {
                //debugger;
                props.SetHasPersonalData(true);
              } else {
                props.SetHasPersonalData(false);
              }

              get(`PersonaVehiculo/HasData/${props.user.persona.id}`).then(
                (response) => {
                  props.SetHasVehicle(response.data);
                }
              );

              get(`PersonaFamilia/HasData/${props.user.persona.id}`).then(
                (response) => {
                  props.SetHasFamilyStructure(response.data);
                }
              );

              get(`PersonaEducacion/HasData/${props.user.persona.id}`).then(
                (response) => {
                  props.SetHasEducation(response.data);
                }
              );

              get(`PersonaIdioma/HasData/${props.user.persona.id}`).then(
                (response) => {
                  props.SetHasLanguage(response.data);
                }
              );

              get(`PersonaConocimiento/HasData/${props.user.persona.id}`).then(
                (response) => {
                  props.SetHasKnowledge(response.data);
                }
              );

              get(`PersonaExperiencia/HasData/${props.user.persona.id}`).then(
                (response) => {
                  props.SetHasExperience(response.data);
                }
              );

              get(`PersonaReferencia/HasData/${props.user.persona.id}`).then(
                (response) => {
                  props.SetHasRefenceData(response.data);
                }
              );

              get(`SolicitudEmpleo/HasData/${props.user.persona.id}`).then(
                (response) => {
                  props.SetHasJobInformation(response.data);
                }
              );

              get(`PersonaDocumento/HasData/${props.user.persona.id}`).then(
                (response) => {
                  props.SetHasAttachment(response.data);
                }
              );
              get(`PersonaTalento/HasData/${props.user.persona.id}`).then(
                (response) => {
                  props.SetHasTalentsData(response.data);
                }
              );
            } else {
              logOut();
            }
          } catch (e) {
            logOut();
          }
        } else {
          logOut();
        }
      }
    })();
  }, []);

  const logOut = () => {
    props.SetUser({});
    props.SetLoggedIn(false);
    props.SetHasPersonalData(false);
    props.SetHasVehicle(false);
    props.SetHasFamilyStructure(false);
    props.SetHasEducation(false);
    props.SetHasLanguage(false);
    props.SetHasKnowledge(false);
    props.SetHasExperience(false);
    props.SetHasRefenceData(false);
    props.SetHasJobInformation(false);
    props.SetHasAttachment(false);
    props.SetIsRequiredModule(false);
    props.SetHasTalentsData(false);
    localStorage.removeItem("currentUser-ARS");
    localStorage.removeItem("token-ARS");

    history.push({
      pathname: "/",
      state: {},
    });
  };

  return <>{props.isLoggedIn ? <Layout /> : <Router />}</>;
};

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.isLoggedIn,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    SetUser: (user) => dispatch(SetUser(user)),
    SetLoggedIn: (value) => dispatch(SetLoggedIn(value)),
    SetHasPersonalData: (value) => dispatch(SetHasPersonalData(value)),
    SetHasVehicle: (value) => dispatch(SetHasVehicle(value)),
    SetHasFamilyStructure: (value) => dispatch(SetHasFamilyStructure(value)),
    SetHasEducation: (value) => dispatch(SetHasEducation(value)),
    SetHasLanguage: (value) => dispatch(SetHasLanguage(value)),
    SetHasKnowledge: (value) => dispatch(SetHasKnowledge(value)),
    SetHasExperience: (value) => dispatch(SetHasExperience(value)),
    SetHasRefenceData: (value) => dispatch(SetHasRefenceData(value)),
    SetHasJobInformation: (value) => dispatch(SetHasJobInformation(value)),
    SetHasAttachment: (value) => dispatch(SetHasAttachment(value)),
    SetIsRequiredModule: (value) => dispatch(SetIsRequiredModule(value)),
    SetHasTalentsData: (value) => dispatch(SetHasTalentsData(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
